import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'atoms/Modal';
import { ModalProps } from 'atoms/Modal/ModalTypes';
import StyledInfoModal from './../InfoModal/StyledInfoModal';
import Button from 'styled/components/Button';
import { modalsActions } from 'features/modals/modalsSlice';
import EmptyCacheButton from '../../EmptyCacheButton';
import { timeSliceActions } from '../../../features/time/timeSlice';
import { selectMatch } from '../../../features/match/matchSlice';

const ConsiderReloadModal: React.FC<ModalProps> = (props) => {
  const dispatch = useDispatch();
  const match = useSelector(selectMatch);

  const reload = () => {
    dispatch(timeSliceActions.emptyLocalStorage(match.id));
    window.location.reload();
  };

  return (
    <Modal {...props}>
      <StyledInfoModal vertical={true}>
        <div className="info reload">
          <span className="title">
            <FormattedMessage id="modals.reload.title" />
          </span>
          <span className="description">
            <FormattedMessage id="modals.reload.description" />
          </span>
        </div>
        <div className="actions actionsReload">
          <Button
            onClick={() => {
              dispatch(modalsActions.setConsiderReloadModal(false));
            }}
          >
            <FormattedMessage id="modals.info.close" />
          </Button>
          <EmptyCacheButton onClick={reload} />
        </div>
      </StyledInfoModal>
    </Modal>
  );
};

export default ConsiderReloadModal;
